// components/ProductSpecsTable.js
import React from 'react';
import { Table, TableHead, TableBody, TableRow, TableCell, TextField, IconButton, Button, Tooltip } from "@mui/material";
import { Delete, Add } from "@mui/icons-material";

const ProductSpecsTable = ({ specs, setSpecs }) => {

    const handleAddRow = () => {
        setSpecs([...specs, { spec_key: '', spec_value: '', sort_order: specs.length }]);
    };

    const handleRemoveRow = (index) => {
        const updated = [...specs];
        updated.splice(index, 1);
        setSpecs(updated);
    };

    const handleChange = (index, field, value) => {
        const updated = [...specs];
        updated[index][field] = value;
        setSpecs(updated);
    };

    return (
        <>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ width: "45%" }}>項目名</TableCell>
                        <TableCell sx={{ width: "45%" }}>内容</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {specs.map((spec, idx) => (
                        <TableRow key={idx}>
                            <TableCell>
                                <TextField
                                    value={spec.spec_key}
                                    onChange={(e) => handleChange(idx, "spec_key", e.target.value)}
                                    error={spec.spec_key.length > 100}
                                    helperText={
                                        spec.spec_key.length > 100
                                            ? '項目名は100文字以内で入力してください'
                                            : ''
                                    }
                                    inputProps={{ maxLength: 100 }}
                                    multiline
                                    minRows={1}
                                    maxRows={10}
                                />
                            </TableCell>

                            <TableCell>
                                <TextField
                                    value={spec.spec_value}
                                    onChange={(e) => handleChange(idx, "spec_value", e.target.value)}
                                    error={spec.spec_value.length > 255}
                                    helperText={
                                        spec.spec_value.length > 255
                                            ? '内容は255文字以内で入力してください'
                                            : ''
                                    }
                                    inputProps={{ maxLength: 255 }}
                                    multiline
                                    minRows={1}
                                    maxRows={20}
                                />
                            </TableCell>

                            <TableCell>
                                <Tooltip title='削除する'>
                                    <IconButton
                                        onClick={() => handleRemoveRow(idx)}
                                    >
                                        <Delete />
                                    </IconButton>
                                </Tooltip>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

            <Button
                type="button"
                startIcon={<Add />}
                sx={{ mt: 1 }}
                variant="outlined"
                size="small"
                onClick={handleAddRow}
            >
                行を追加
            </Button>
        </>
    );
};

export default ProductSpecsTable;
